import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

/**
 * Start Agora recording
 * @param action - Action containing payload with channel_name, uid, schedule_id
 */
export function* startRecording(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AGORA_RECORDING.START, action.payload, true);
}

/**
 * Stop Agora recording
 * @param action - Action containing payload with channel_name, uid, resource_id, sid, schedule_id
 */
export function* stopRecording(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AGORA_RECORDING.STOP, action.payload, true);
}

/**
 * Query Agora recording status
 * @param action - Action containing payload with channel_name, uid, resource_id, sid, schedule_id
 */
export function* queryRecording(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AGORA_RECORDING.QUERY, action.payload, true);
}

/**
 * Create instant call or get instant call details
 * @param action - Action containing payload with channel_name (for GET) or call creation data (for POST)
 */
export function* instantCall(action: any): any {
  const { channel_name, method = "POST" } = action.payload || {};

  // If channel_name is provided, it's a GET request to fetch call details
  if (channel_name && method === "GET") {
    const url = `${API_URL.AGORA.INSTANT_CALL}?channel_name=${channel_name}`;
    yield call(sagaFunction, action, CallApi.GET, url, {}, true);
  } else {
    // Otherwise, it's a POST request to create a new instant call
    yield call(sagaFunction, action, CallApi.POST, API_URL.AGORA.INSTANT_CALL, action.payload, true);
  }
}
